module.exports = __webpack_public_path__ + "img/oak-tree.111ad7b1.svg";